<template>
  <div
    :style="{
      visibility:
        (newLicence && applicationPrice) || (!newLicence && options.length > 0)
          ? 'visible'
          : 'hidden',
    }"
  >
    <v-row v-if="newLicence" justify="end">
      <v-col cols="12" class="text-h6 text-center">
        Total :
        {{ editedItem.quantity }} x
        <span v-if="options.length > 0"
          >(
          {{ applicationPrice ? applicationPrice.toFormat() : "" }}
          <span v-if="discount" class="red--text"
            >- {{ discount.percent }}%</span
          >+ {{ optionsPriceFormatted }})</span
        >
        <span v-else>
          {{ applicationPrice ? applicationPrice.toFormat() : "" }}
          <span v-if="discount" class="red--text"
            >- {{ discount.percent }}%</span
          ></span
        >
        = {{ total }}
      </v-col>
    </v-row>
    <v-row v-else justify="end">
      <v-col cols="12" class="text-h6 text-center">
        Total :
        <span v-if="options.length > 1">
          {{ optionsPriceFormatted }}
          = </span
        >{{ total }}
      </v-col>
    </v-row>
    <v-alert v-if="nextDiscount" type="info" icon="mdi-sale" min-height="75">{{
      infoDiscount
    }}</v-alert>
  </div>
</template>

<script>
import Dinero from "dinero.js";
import { mapState } from "vuex";

export default {
  name: "TotalLicencePrice",
  props: ["price", "options", "discount", "nextDiscount"],
  computed: {
    ...mapState({
      editedId: (state) => state.licences.editedId,
      discounts: (state) => state.licences.discounts,
      editedItem: (state) => state.licences.editedItem,
    }),
    newLicence() {
      return this.editedId === -1;
    },
    infoDiscount() {
      let info = "";

      if (this.nextDiscount) {
        const remainQuantity =
          this.nextDiscount.quantity - this.editedItem.quantity;

        info = this.$t("info-discount", {
          remainQuantity,
          percent: this.nextDiscount.percent,
        });
      } else if (this.discount) {
        info = this.$t("info-discount", {
          remainQuantity: 1,
          percent: this.discount.percent,
        });
      }

      return info;
    },
    applicationPrice() {
      return this.price ? this.toPrice(this.price?.amount) : null;
    },
    optionsPrice() {
      let total = this.toPrice(0);

      this.options.forEach((option) => {
        let dineroPrice = this.toPrice(option.amount);
        total = total.add(dineroPrice);
      });

      return total;
    },
    optionsPriceFormatted() {
      const arrayPrices = this.options.reduce((acc, option) => {
        acc.push(this.toPrice(option.amount).toFormat());
        return acc;
      }, []);

      return arrayPrices.join(" + ");
    },
    total() {
      let total = "";

      if (this.newLicence && this.applicationPrice && this.discount) {
        const discountAmount = this.applicationPrice.percentage(
          this.discount.percent
        );

        total = this.applicationPrice
          .subtract(discountAmount)
          .add(this.optionsPrice)
          .multiply(this.editedItem.quantity)
          .toFormat();
      } else if (this.newLicence && this.applicationPrice) {
        total = this.applicationPrice
          .add(this.optionsPrice)
          .multiply(this.editedItem.quantity)
          .toFormat();
      } else if (this.optionsPrice) {
        total = this.optionsPrice.toFormat();
      }

      this.$store.commit("licences/setTotal", total);
      return total;
    },
  },
  methods: {
    toPrice(value) {
      return Dinero({ amount: value });
    },
  },
};
</script>